export default __webpack_public_path__ + "static/media/white_princess.441bc40b.png";